var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pages container"},[_c('v-title',{attrs:{"value":_vm.aboutUsStore.name}}),_c('div',{staticClass:"pages-wrap",domProps:{"innerHTML":_vm._s(_vm.aboutUsStore.content)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }